import Honeypot from "./Honeypot";

export default Honeypot;
